import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  RequestTypes,
  permitKeys,
} from '@core/react-query/features/permits/permit'
import { IPermit } from '@core/entities/permit/Permit'
import { useMutateQueryData } from '@core/react-query/hooks'
import { permitsKeys } from '@core/react-query/features/permits'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { localizedStrings } from '@core/strings'

export const useRequestPermitChanges = () => {
  const queryClient = useQueryClient()
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return useMutation<IPermit, RequestErrorType, RequestTypes['requestChanges']>(
    {
      ...permitKeys.requestChanges,
      meta: { name: localizedStrings.requestChanges },
      onSuccess: (permit) => {
        queryClient.setQueryData(
          permitKeys.byId({ permitId: permit.id }).queryKey,
          permit,
        )
        updateInfiniteQueryItem(
          permitsKeys
            .allPermits({
              organisationId: permit.organisationId,
              projectIds: [permit.project.id],
            })
            .queryKey.slice(0, -3),
          permit,
        )
      },
    },
  )
}
